import { useParams, useNavigate } from "react-router-dom"
import { useOvertime } from "@/contexts/overtime/useOvertime"
import ApprovalForm from "@/components/overtime/ApprovalForm"
import { Button } from "@/components/ui/button"
import { ArrowLeft } from "lucide-react"
import { Skeleton } from "@/components/ui/skeleton"
import { OvertimeStatus } from "@/types/enums"

const ApproveRequest = () => {
  const { requestId } = useParams<{ requestId: string }>()
  const { getOvertimeRequestById, loading } = useOvertime()
  const navigate = useNavigate()
  
  if (loading) {
    return (
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Approve Request</h1>
            <p className="text-muted-foreground">Loading request details...</p>
          </div>
        </div>
        <Skeleton className="h-[400px] w-full" />
      </div>
    )
  }
  
  if (!requestId) {
    return (
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Approve Request</h1>
          <p className="text-muted-foreground">Invalid request ID</p>
        </div>
        <Button 
  onClick={() => navigate('/pending-requests')}
  variant="secondary"
  size="sm"
  className="flex items-center gap-1 shadow-sm px-4 py-2"
  aria-label="Go back to pending requests"
>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Go Back
        </Button>
      </div>
    )
  }
  
  const request = getOvertimeRequestById(requestId)
  
  if (!request) {
    return (
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Approve Request</h1>
          <p className="text-muted-foreground">Request not found</p>
        </div>
        <Button 
  onClick={() => navigate('/pending-requests')}
  variant="secondary"
  size="sm"
  className="flex items-center gap-1 shadow-sm px-4 py-2"
  aria-label="Go back to pending requests"
>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Go Back
        </Button>
      </div>
    )
  }
  
  if (request.status !== OvertimeStatus.PENDING && request.status !== OvertimeStatus.PENDING_VP_APPROVAL) {
    return (
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Approve Request</h1>
          <p className="text-muted-foreground">
            This request has already been {request.status}
          </p>
        </div>
        <Button 
  onClick={() => navigate('/pending-requests')}
  variant="secondary"
  size="sm"
  className="flex items-center gap-1 shadow-sm px-4 py-2"
  aria-label="Go back to pending requests"
>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Go Back
        </Button>
      </div>
    )
  }
  
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Approve Request</h1>
          <p className="text-muted-foreground">
            Review and approve overtime request
          </p>
        </div>
        <Button 
  onClick={() => navigate('/pending-requests')}
  variant="secondary"
  size="sm"
  className="flex items-center gap-1 shadow-sm px-4 py-2"
  aria-label="Go back to pending requests"
>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Requests
        </Button>
      </div>
      
      <ApprovalForm request={request} type="approve" />
    </div>
  )
}

export default ApproveRequest
